import { defineThemeConfig } from '@core'
import { Skins } from '@core/enums'
import { breakpointsVuetifyV3 } from '@vueuse/core'
import { VIcon } from 'vuetify/components/VIcon'

// ❗ Logo SVG must be imported with ?raw suffix
import logo from '@images/aspial_logo.png'
import {
    AppContentLayoutNav,
    ContentWidth,
    FooterType,
    NavbarType,
} from '@layouts/enums'
import { h } from 'vue'

export const { themeConfig, layoutConfig } = defineThemeConfig({
    app: {
        title: 'materio',

        // ❗ if you have SVG logo and want it to adapt according to theme color, you have to apply color as `color: rgb(var(--v-global-theme-primary))`
        // logo: h("div", {
        //   innerHTML: logo,
        //   style: "line-height:0; color: rgb(var(--v-global-theme-primary))",
        // }),
        logo: h('img', {
            src: logo,
        }),
        contentWidth: ContentWidth.Fluid,
        contentLayoutNav: AppContentLayoutNav.Vertical,
        overlayNavFromBreakpoint: breakpointsVuetifyV3.lg - 1, // 1 for matching with vuetify breakpoint. Docs: https://next.vuetifyjs.com/en/features/display-and-platform/
        i18n: {
            enable: true,
            defaultLocale: 'en',
            langConfig: [
                {
                    label: 'English',
                    i18nLang: 'en',
                    isRTL: false,
                },
                {
                    label: 'French',
                    i18nLang: 'fr',
                    isRTL: false,
                },
                {
                    label: 'Arabic',
                    i18nLang: 'ar',
                    isRTL: true,
                },
            ],
        },
        theme: 'light',
        skin: Skins.Bordered,
        iconRenderer: VIcon,
    },
    navbar: {
        type: NavbarType.Sticky,
        navbarBlur: true,
    },
    footer: { type: FooterType.Static },
    verticalNav: {
        isVerticalNavCollapsed: true, // Set to true to collapse by default
        defaultNavItemIconProps: { icon: 'ri-circle-line' },
        isVerticalNavSemiDark: true,
    },
    horizontalNav: {
        type: 'sticky',
        transition: 'slide-y-reverse-transition',
        popoverOffset: 4,
    },

    /*
    // ℹ️  In below Icons section, you can specify icon for each component. Also you can use other props of v-icon component like `color` and `size` for each icon.
    // Such as: chevronDown: { icon: 'ri-arrow-down-s-line', color:'primary', size: '24' },
    */
    icons: {
        chevronDown: { icon: 'ri-arrow-down-s-line' },
        chevronRight: { icon: 'ri-arrow-right-s-line' },
        close: { icon: 'ri-close-line', size: '20' },
        verticalNavPinned: { icon: 'ri-radio-button-line', size: '20' },
        verticalNavUnPinned: { icon: 'ri-circle-line', size: '20' },
        sectionTitlePlaceholder: { icon: 'ri-subtract-line' },
    },
})
